import { NgModule } from '@angular/core';
import { CoreCommonModule } from '@core/common.module';
import { CardSnippetModule } from '@core/components/card-snippet/card-snippet.module';
import { CsvModule } from '@ctrl/ngx-csv';
import { NgbModule, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { TranslateModule } from '@ngx-translate/core';
import { SweetAlert2Module } from '@sweetalert2/ngx-sweetalert2';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { ContentHeaderModule } from 'app/layout/components/content-header/content-header.module';
import { SharedModule } from 'app/shared/shared.module';
import { AssiggnmentToFlightComponent } from './assiggnment-to-flight/assiggnment-to-flight.component';
import { AssignmentToDealerComponent } from './assignment-to-dealer/assignment-to-dealer.component';
import { BillCreateComponent } from './bill-create/bill-create.component';
import { BillComponent } from './bill/bill.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { DealerBalanceComponent } from './dealer-balance/dealer-balance.component';
import { DealersCreateComponent } from './dealers-create/dealers-create.component';
import { DealersComponent } from './dealers/dealers.component';
import { OrdersComponent } from './orders/orders.component';
import { FlightComponent } from './flight/flight.component';
import { FlightBillsComponent } from './flight-bills/flight-bills.component';
import { BillSummaryShipmentComponent } from './bill-summary-shipment/bill-summary-shipment.component';
import { PagesRoutingModule } from './pages-routing.module';
import { ShippingComponent } from './shipping/shipping.component';
import { ScannerComponent } from './scanner/scanner.component';
import { BillsToDispatchComponent } from './bills-to-dispatch/bills-to-dispatch.component';
import { DealerDispatchsComponent } from './dealer-dispatchs/dealer-dispatchs.component';
import { DealerBalanceCreateComponent } from './dealer-balance-create/dealer-balance-create.component';
import { ShippingBalanceComponent } from './shipping-balance/shipping-balance.component';
import { ShippingBalanceCreateComponent } from './shipping-balance-create/shipping-balance-create.component';
import { BashToFlightComponent } from './bash-to-flight/bash-to-flight.component';
import { BillBatchCreateComponent } from './bill-batch-create/bill-batch-create.component';
import { TemporaryBillsComponent } from './temporary-bills/temporary-bills.component';
import { MatChipsModule } from '@angular/material/chips';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatRippleModule} from '@angular/material/core';
import {MatTableModule} from '@angular/material/table';
import {MatSortModule} from '@angular/material/sort';
import { MatButtonModule } from '@angular/material/button';
import {MatIconModule} from '@angular/material/icon';
import {MatPaginatorModule} from '@angular/material/paginator';
import {AutocompleteLibModule} from 'angular-ng-autocomplete';


@NgModule({
  declarations: [
    ShippingComponent,
    ScannerComponent,
    DashboardComponent,
    FlightComponent,
    BillComponent,
    BillCreateComponent,
    AssiggnmentToFlightComponent,
    AssignmentToDealerComponent,
    DealersComponent,
    DealersCreateComponent,
    DealerBalanceComponent,
    DealerBalanceCreateComponent,
    BillsToDispatchComponent,
    DealerDispatchsComponent,
    ShippingBalanceComponent,
    ShippingBalanceCreateComponent,
    BashToFlightComponent,
    BillBatchCreateComponent,
    TemporaryBillsComponent,
    FlightBillsComponent,
    BillSummaryShipmentComponent,
    OrdersComponent
  ],
  imports: [
    PagesRoutingModule,
    NgbModule,
    TranslateModule,
    CoreCommonModule,
    ContentHeaderModule,
    CardSnippetModule,
    NgxDatatableModule,
    MatSortModule,
    MatInputModule,
    CsvModule,    
    SweetAlert2Module.forRoot(),
    NgSelectModule,
    NgbTooltipModule,
    SharedModule,
    MatChipsModule,   
    MatTableModule, 
    MatFormFieldModule,    
    MatRippleModule,
    MatIconModule,
    MatButtonModule,
    MatPaginatorModule,
    AutocompleteLibModule
  ],
  exports: [
    MatChipsModule,    
    MatFormFieldModule,    
    MatRippleModule,
    MatIconModule,
    MatSortModule,
    MatTableModule,
    MatInputModule,
    MatButtonModule,
    MatPaginatorModule
  ],
  bootstrap: [DealerDispatchsComponent]
})
export class PagesModule { }
